/**
 * Button CSS Generator
 *
 * Generate complete CSS for button control group using responsive CSS generator.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { generateResponsiveCSS } from '../../common';
import type { ButtonAttributes } from '../types';
import { generateButtonCSSRules } from './rules';

/**
 * Generate complete CSS for button control group
 */
export const getButtonCSS = (
	attributes: ButtonAttributes,
	selector: string = '',
): string => {
	return generateResponsiveCSS(
		attributes,
		selector,
		generateButtonCSSRules,
	);
};
